<template>
  <div
    v-if="isLoad"
    class="box-placeholder"
  >
    <div class="excerpt">
      <div class="text" />
      <div class="text" />
      <div class="text" />
      <div class="text" />
      <div class="text" />
      <div class="text" />
      <div class="text" />
      <div class="text" />
      <div class="text" />
      <div class="text" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isLoad: {
      type: Boolean,
      default: () => true,
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/plugins/PlaceholderContent.vue